import { AuxiliumComponent } from "../auxilium-component";

export default class Filter extends AuxiliumComponent {
  static observable = ["name", "value", "query-parameter"];

  constructor() {
    super();

    if (this.queryParameter) {
      this.value = Browser.GetURLParameter(this.queryParameter);
    }
  }

  #Dropdown = null;

  #Icon = document.createElementWithContents("chip-button", null, {
    variation: "secondary",
    className: "filter--remove",
    buttonStyle: "icon",
    tooltip: this.value ? Localizer.FILTER_REMOVE : "",
    size: "xs",
    flush: true,
    icon: this.value ? "fas fa-times fa-fw" : "fas fa-plus fa-fw",
    pill: true,
    onclick: () => this.#actionClicked()
  });

  parsedCallback() {
    this.#Dropdown = this.querySelector(":scope > chip-dropdown");
    this.appendChild(this.#Icon);

    this.appendChild(document.createElementWithContents("chip-text", this.name, {
      className: "filter--name"
    }));

    this.appendChild(document.createElementWithContents("div", null, {
      className: "filter--separator"
    }));

    if (this.#Dropdown) {
      Object.assign(this.#Dropdown, {
        dropdownStyle: "minimal",
        value: this.value,
        onchange: () => {
          this.value = this.#Dropdown.value;

          if (this.queryParameter) {
            Browser.SetURLParameter(this.queryParameter, this.value);
          }
        }
      });

      this.appendChild(this.#Dropdown);
    }
  }

  attributeChanged(name, _, newValue) {
    if (name === "value" && this.#Dropdown) {
      this.#Dropdown.value = newValue;

      if (newValue) {
        Object.assign(this.#Icon, {
          icon: "fas fa-times fa-fw",
          tooltip: Localizer.FILTER_REMOVE
        });
      } else {
        Object.assign(this.#Icon, {
          icon: "fas fa-plus fa-fw",
          tooltip: ""
        });
      }
    }
  }

  #actionClicked() {
    if (this.value) {
      this.value = "";

      if (this.queryParameter) {
        Browser.SetURLParameter(this.queryParameter, this.value);
      }
    } else if (this.#Dropdown) {
      this.#Dropdown.Open();
    }
  }
}
